export default {
  contador: state => state.mobiliario.cadastro.contador
};